
    import Vue from 'vue';
    import AsModal from '@/components/Ui/AsModal.vue';
    import AsHeadline from '@/components/Ui/AsHeadline.vue';

    import { settingsHelper } from '@/store/modules/settings';
    const settingsHelpers = settingsHelper.mapGetters(['locale']);

    export default Vue.extend({
        name: 'IsSafe',

        components: {
            AsModal,
            AsHeadline,
        },
        computed: {
            ...settingsHelpers,
            uk(): boolean {
                return this.locale.current === 'en-GB';
            },
            heading(): string {
                return this.uk
                    ? "How consents.online protects your data"
                    : "How AccountScore protects your data"
            }
        },
    });
